import { CircularProgress, Typography } from '@mui/material'
import { FlipCameraIos } from '@mui/icons-material'

import { LoadingButton } from 'components/mui'

import { useSPDCortexScannerContext } from '../SPDCortexScanner.context'

import './SPDCortexVideo.scss'
import { useSPDCortexVideo } from './SPDCortexVideo.logic'
import classNames from 'classnames'
import {
  CortexReceivingVideo,
  useCortexDecoderContext,
} from 'lib/scanner/compatibility'
import { useEffect } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ScanbotReceivingVideo } from 'lib/scanner/scanbot/ScanbotVideo'

const SPDCortexVideo = ({
  onScan,
  isEnabled = true,
}: {
  onScan: (newScan: CortexDecoder.CDResult) => void
  isEnabled?: boolean
}) => {
  const { handleToggleCameraMenu, isCameraMenuOpen, handleCameraChange } =
    useSPDCortexVideo({
      onScan,
      isEnabled,
    })
  const { cameras, selectedCamera } = useSPDCortexScannerContext()
  const { changeCamera } = useCortexDecoderContext()
  const flags = useFlags()
  const isScanbotEnabled = flags.useScanbotSdk

  useEffect(() => {
    if (selectedCamera) {
      changeCamera(selectedCamera.deviceId)
    }
  }, [selectedCamera, changeCamera])

  return (
    <>
      {cameras.length === 0 || !selectedCamera ? (
        <CircularProgress />
      ) : (
        <div className="spd-cortex-video_wrapper">
          <div className="camera-select_container">
            <LoadingButton
              variant="contained"
              loading={false}
              onClick={handleToggleCameraMenu}
              startIcon={<FlipCameraIos />}
              className="camera-switch"
            >
              Switch Camera
            </LoadingButton>

            {isCameraMenuOpen && (
              <div className="camera-options">
                {cameras.map((camera: any) => (
                  <div
                    key={camera.deviceId}
                    className={classNames('camera-option', {
                      active: camera.deviceId === selectedCamera?.deviceId,
                    })}
                    onClick={() => handleCameraChange(camera)}
                  >
                    <Typography className="label">{camera.label}</Typography>
                    <Typography className="type">
                      {camera?.cameraType}
                    </Typography>
                  </div>
                ))}
              </div>
            )}
          </div>

          {isScanbotEnabled ? (
            <ScanbotReceivingVideo width="100%" height="100%" />
          ) : (
            <CortexReceivingVideo width="100%" height="100%" />
          )}
        </div>
      )}
    </>
  )
}

export default SPDCortexVideo
